import { AnalyticsEvent } from '../../analytics.event';

export class UserLoginEvent extends AnalyticsEvent {
    constructor(method: string) {
        super('user_login', { method });
    }
}
